// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_S","tabbox":"_T","tabBar":"_U","tabBar__tabBaritem":"_V","tabBar__tabBaritemAction":"_W"};